// extracted by mini-css-extract-plugin
export default {"sideNav_head":"NavBar_sideNav_head__e8B86","sideNav_cap":"NavBar_sideNav_cap__BgqU4","sideNav_sm":"NavBar_sideNav_sm__1v5rG","sideNav_copyright":"NavBar_sideNav_copyright__9EsYG"};